import { computed } from 'vue';

const namedApiInboxIconMap = {
  telegram: 'i-ri-telegram-fill',
  whatsapp: 'i-woot-whatsapp',
};

const isNamedApiInbox = (inbox, name) => {
  return (
    inbox.channel_type === 'Channel::Api' &&
    inbox.name?.trim().toLowerCase() === name
  );
};

export const getNamedApiInboxIcon = name => {
  return namedApiInboxIconMap[name?.trim().toLowerCase()] || '';
};

export function useChannelIcon(inbox) {
  const channelTypeIconMap = {
    'Channel::Api': 'i-woot-api',
    'Channel::Email': 'i-woot-mail',
    'Channel::FacebookPage': 'i-woot-messenger',
    'Channel::Line': 'i-woot-line',
    'Channel::Sms': 'i-woot-sms',
    'Channel::Telegram': 'i-ri-telegram-fill',
    'Channel::TwilioSms': 'i-woot-sms',
    'Channel::TwitterProfile': 'i-woot-x',
    'Channel::WebWidget': 'i-ri-global-line',
    'Channel::Whatsapp': 'i-woot-whatsapp',
    'Channel::Instagram': 'i-woot-instagram',
    'Channel::Tiktok': 'i-woot-tiktok',
    'Channel::Voice': 'i-woot-voice',
  };

  const providerIconMap = {
    microsoft: 'i-woot-outlook',
    google: 'i-woot-gmail',
  };

  const channelIcon = computed(() => {
    const inboxDetails = inbox.value || inbox;
    const type = inboxDetails.channel_type;

    const namedApiIcon = Object.keys(namedApiInboxIconMap).find(name =>
      isNamedApiInbox(inboxDetails, name)
    );

    if (namedApiIcon) {
      return namedApiInboxIconMap[namedApiIcon];
    }

    let icon = channelTypeIconMap[type];

    if (type === 'Channel::Email' && inboxDetails.provider) {
      if (Object.keys(providerIconMap).includes(inboxDetails.provider)) {
        icon = providerIconMap[inboxDetails.provider];
      }
    }

    // Special case for Twilio whatsapp
    if (type === 'Channel::TwilioSms' && inboxDetails.medium === 'whatsapp') {
      icon = 'i-woot-whatsapp';
    }

    return icon ?? 'i-ri-global-fill';
  });

  return channelIcon;
}
